import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ToastTypes, withToast } from "../../contexts/toastr.context";
import { CommunityPac } from "../../types/community/community-pac.type";
import { User } from "../../types/user/minimal-user.type";
import { Button } from "../../_components";
import PremiumFeature from "../../_components/premium/premium-feature.component";
import { UserApiKeysService } from "../../_service/user-api-keys.service";
export const USER_API_KEYS_PAGE_ROUTE = "/settings/apis-keys";

interface UserApiKeysPageProps {
  user: User;
  addToast: any;
  communityPac: CommunityPac;
}
export function UserApiKeysPageComponent({
  user,
  addToast,
  communityPac,
}: UserApiKeysPageProps) {
  const [userApiKeys, setUserApiKeys] = useState<string[]>([]);

  // get all the user api keys available
  useEffect(() => {
    UserApiKeysService.getKeys(user)
      .then(({ apiKeys }) => {
        setUserApiKeys(apiKeys);
      })
      .catch((error) => {
        addToast("User api keys could not be fetched!", "", ToastTypes.danger);
      });
  }, [user]);

  const createNewKey = () => {
    const keyName = window.prompt("Please enter a name for the new key", "");
    if (keyName) {
      UserApiKeysService.createKey(user, keyName)
        .then(({ apiKey }) => {
          setUserApiKeys([...userApiKeys, apiKey]);
          addToast("User api key created!", "", ToastTypes.success);
        })
        .catch((error) => {
          addToast(
            "User api keys could not be created!",
            "",
            ToastTypes.danger
          );
        });
    }
  };

  const deleteKey = (keyId: string, index: number) => {
    if (window.confirm("Are you sure you want to delete this key?")) {
      UserApiKeysService.deleteKey(user, keyId)
        .then(() => {
          const newList = [...userApiKeys];
          newList.splice(index, 1);
          setUserApiKeys(newList);
          addToast("User api key deleted!", "", ToastTypes.success);
        })
        .catch((error) => {
          addToast(
            "User api keys could not be deleted!",
            "",
            ToastTypes.danger
          );
        });
    }
  };

  return (
    <PremiumFeature isAvailable={communityPac.apiKeysAccess} hideFeature>
      <div className="UserApiKeysPage rounded pensil-card theme-bg-surface shadow">
        <div className="main-content">
          {/* header card */}
          <div className="p-4 border-b theme-border-default flex items-start justify-between">
            <div>
              <div className="font-bold theme-text-heading-2">API Keys</div>
              <div className="mt-2 text-sm">
                Total Keys: {userApiKeys.length}
              </div>
            </div>
            {/* create new key button */}
            <Button
              label="Create New Key"
              className="mx-2"
              onClick={createNewKey}
            />
          </div>
          {/* warning to keep the api keys safe */}
          <div className="p-4 py-10 text-sm theme-text-danger text-center">
            Keep your API keys safe! You can use them to access specific
            functionality and let certain apps perform actions on your behalf on
            the platform.
          </div>
          {/* key list */}
          <table className="table-fixed border-collapse w-full">
            <thead>
              <tr>
                <th className="p-2 whitespace-nowrap border-b theme-border-default text-left">
                  Key Name
                </th>
                <th className="p-2 border-b theme-border-default text-left">
                  Key Value
                </th>
                <th className="p-2 whitespace-nowrap border-b flex place-content-end mr-4 theme-border-default">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {userApiKeys.map((apiKey: any, index: number) => (
                <tr key={apiKey._id}>
                  <td className="p-2 whitespace-nowrap">
                    {apiKey.keyName ? apiKey.keyName : "No Name"}
                  </td>
                  <td className="p-2 ">{apiKey.keyValue}</td>
                  <td className="p-2  flex place-content-end whitespace-nowrap text-center">
                    <Button
                      label="Delete"
                      className="mx-2"
                      onClick={() => {
                        deleteKey(apiKey._id, index);
                      }}
                    />
                  </td>
                </tr>
              ))}
              {userApiKeys.length === 0 && (
                <tr>
                  <td
                    colSpan={3}
                    className="p-2 py-4  whitespace-nowrap text-center">
                    No keys available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </PremiumFeature>
  );
}

const stp = (state: any) => ({
  user: state.auth,
  communityPac: state.communityPac,
});

const UserApiKeysPage = withToast(connect(stp)(UserApiKeysPageComponent));

export default UserApiKeysPage;
